// extracted by mini-css-extract-plugin
var _1 = "ActivityItem-module__activityAvatars--_ZEtr";
var _2 = "ActivityItem-module__activityFirstRow--8INbE";
var _3 = "ActivityItem-module__activityIcon--C5J_o";
var _4 = "ActivityItem-module__activityInner--kKtZl";
var _5 = "ActivityItem-module__activityItem--NquE6";
var _6 = "ActivityItem-module__activityNames--gmOcM";
var _7 = "ActivityItem-module__activitySecondRow--VILgi";
var _8 = "ActivityItem-module__activitySeparatorIcon--gVOfh";
var _9 = "ActivityItem-module__activitySeparatorText--twVYE";
var _a = "ActivityItem-module__activityTime--i3132";
var _b = "ActivityItem-module__activityVerticalLine--Jvism";
var _c = "ActivityItem-module__animateUploadProgressBarWidth--Fea8d";
var _d = "ActivityItem-module__animatedBackground--tohPz";
var _e = "ActivityItem-module__green--Dt1xv";
var _f = "ActivityItem-module__hoverIndicator--jHTIf";
var _10 = "ActivityItem-module__isInteractive--p6InU";
var _11 = "ActivityItem-module__pink--itAvm";
var _12 = "ActivityItem-module__yellow--W6B4S";
export { _1 as "activityAvatars", _2 as "activityFirstRow", _3 as "activityIcon", _4 as "activityInner", _5 as "activityItem", _6 as "activityNames", _7 as "activitySecondRow", _8 as "activitySeparatorIcon", _9 as "activitySeparatorText", _a as "activityTime", _b as "activityVerticalLine", _c as "animateUploadProgressBarWidth", _d as "animatedBackground", _e as "green", _f as "hoverIndicator", _10 as "isInteractive", _11 as "pink", _12 as "yellow" }
